const stringTimeToDuration = (time?: string) => {
  if (!time) return 0;

  const splitted = time.split(':');
  const hours = splitted.length === 3 ? parseInt(splitted[0]) : 0;
  const minutes = parseInt(splitted[hours ? 1 : 0]);
  const seconds = parseInt(splitted[hours ? 2 : 1]);

  return hours * 60 * 60 + minutes * 60 + seconds;
};

export default stringTimeToDuration;
